import { LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { TableSkeleton } from "../../../helper/TableSkeleton";
import ListingTable from "../../../listing/listing";

export const EventdayarrNotCreated = ({ eventdayarrNotCreatedListFetched }) => {
    const [eventdayarrNotCreatedList, setEventdayarrNotCreatedList] = useState([]);
    const [listFetchSuccess, setListFetchSuccess] = useState(false);
    const [loaderFlag, setloaderFlag] = useState(true);

    const eventdayarrNotCreatedListObj = {
        tableId: "eventdayarrNotCreatedLists",
        tableTitle: "Eventdayarr Not Created List",
        showReload: true,
        showFilter: true,
        api: {
            url: process.env.REACT_APP_API_URL,
            endPoint: "calendar-api/eventdayarr-not-created",
            // deleteSingleUserEndpoint: "api/delete-user",
            tableCountEndpoint: "calendar-api/eventdayarr-not-created",
        },

        reqBody: {
            "condition": {
                "limit": 10,
                "skip": 0
            },
            "sort": {
                "field": "_id",
                "type": "desc"
            },
            "searchcondition": {
            },
            "count": false
        },
        deleteSingleUserReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },
        deleteMultipleReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },

        //******************************** By Default Rows per page option will be available**************************//

        rowsPerPageOptions: [5, 10, 20, 30],
        sortFields: ["lastname", "email", "type"],
        paginationType: "stackPagination",
        enableRowActionLoader: true,
        customBtnHead: [
            // {
            //     id: "deleteMultiple",
            //     type: "delete_icon",
            //     title: "Delete",
            // },
            // {
            //     id: "editMultiple",
            //     type: "toggle_on_icon",
            //     title: "Status Change",
            // },
            // {
            //     id: "adduser",
            //     type: "add_icon",
            //     title: "ADD USER",
            //     className: "add_user_icon",
            //     default: true,
            // },
        ],
        buttons: [
        ],
        deleteModal: {
            modalClassName: "Delete Modal Deletemodal",
        },
        searchData: {
            heading: "Eventdayarr Not Created List",
            type: "drawer",
            condition_type: "$or",
            formData: {
              id: 'searchForm',
              formWrapperClass: "formWrapperClass",// Can be undefined default will be formCls
              formInlineCLass: "userForm", // Can be undefined default will be formInline
              formButtonClass: "submitbtnsection",
              // submitBtnName: "Search",
              submitBtnEndIcon: "search",
              // resetBtnName: "Reset",
              resetBtnEndIcon: "replay",
              resetForm: true,
              formAdditionalSubmissionData: {},
              fields: [
                // {
                //     id: 0,
                //     label: "Search By Event Title",
                //     name: "event_title",
                //     type: "text",
                //     className: 'list_search_item countDiv__column--col6 ',
                //     sx: { m: 1, minWidth: 300 },
                //     payloadFormat: { key: "event_title", param: "$regex", options: "i" },
        
                //   },
                  {
                    id: 2,
                    label: "Search By Connected Gmail",
                    name: "connected_gmail",
                    type: "text",
                    className: 'list_search_item countDiv__column--col4 ',
                    sx: { m: 1, minWidth: 300 },
                    payloadFormat: { key: "connected_gmail" },
        
                  },
             
                {
                    id: 8,
                    label: "Search by Start Date",
                    name: "start_date_unix",
                    className: 'datePicker',
                    type: 'datePicker',
                    sx: { m: 1, width: 300 },
                    // format: 'dd/MM/yyyy', //////////////////////////// MM should be capital //////////////////
                    className: 'list_search_item countDiv__column--col4 ',
                    payloadFormat: { key: "start_date_unix", param: "$gte" }
                  },
                  {
                    id: 9,
                    label: "Search by End Date",
                    name: "end_date_unix",
                    className: 'list_search_item countDiv__column--col4 ',
                    type: 'datePicker',
                    fullDay: true,
                    sx: { m: 1, width: 300 },
                    // format: 'dd/MM/yyyy'
                    payloadFormat: { key: "end_date_unix", param: "$lte" }
                  },
              ]
            },
        },

        // searchBarData: {
        //     heading: "Search Eventdayarr Not Created List",
        //     api: {
        //         url: process.env.REACT_APP_API_URL,
        //         endPoint: "calendar-api/eventdayarr-not-created",
        //         tableCountEndpoint: "calendar-api/eventdayarr-not-created",
        //         reqBody: {
        //             // count:true,
        //             // "source": "users",
        //             token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MzYzNTZkNDFjZTE3MzAwMDhiOGFhYTUiLCJzZWNyZXQiOiJ6R3RpMnY1enYiLCJpYXQiOjE2Njc5Njg3MzV9.wzFi1CoHbv9QK5cUHbVgSL6LW8m6fR_BaILcT7OcHBQ",
        //             condition: {
        //                 limit: 5,
        //                 skip: 0,
        //             },
        //             sort: {
        //                 type: "desc",
        //                 field: "_id",
        //             },
        //         },
        //     },

        //     searchSettings: {
        //         datesearch: [
        //             {
        //                 id: 0,
        //                 heading: "Search By Joining Date",
        //                 startdatelabel: "Start Date",
        //                 enddatelabel: "End Date",
        //                 className: "formGroup createdon_datetime countDiv__column--col4",
        //                 submit: "Search",
        //                 field: "createdon_datetime",
        //             },
        //         ],
        //         selectsearch: [
        //             {
        //                 id: 1,
        //                 label: "Search By Timezone",
        //                 field: "timezone",
        //                 type: "select",
        //                 values: ["-09:00|America/Anchorage", "-08:00|America/Los_Angeles", "-07:00|America/Phoenix", "-06:00|America/Chicago", "-05:00|America/New_York", "-10:00|Pacific/Honolulu", "+05:30|Asia/Kolkata"],
        //                 // value: "",
        //             },


        //         ],
        //         textsearch: [
        //             {
        //                 id: 2,
        //                 // heading: "Search By First Name",
        //                 label: "Search By Event Title ",
        //                 field: "event_title",
        //                 className: "formGroup event_title countDiv__column--col4",
        //                 value: "",
        //             },
        //             {
        //                 id: 3,
        //                 // heading: "Search By First Name",
        //                 label: "Search By description ",
        //                 field: "description",
        //                 className: "formGroup description countDiv__column--col4",
        //                 value: "",
        //             },
        //         ],

        //     },
        // },
    };

    var modifyTableHeaders =
        [
            { val: "event_title", name: "Event Title" },
            { val: "connected_gmail", name: "Connected Gmail" },
            { val: "user_email", name: "User Email" },
            { val: "timespan", name: "Timespan" },
            { val: "start_date_unix", name: "Start Date Time", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },
            { val: "end_date_unix", name: "End Date Time", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },

        ];

    const getList = async () => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(eventdayarrNotCreatedListObj.reqBody),
        };
        const response = await fetch(
            process.env.REACT_APP_API_URL + "calendar-api/eventdayarr-not-created",
            requestOptions
        );
        const respdata = await response.json();
        console.log("++++cv+++++++", respdata);
        if (respdata && respdata.status === "success") {
            setEventdayarrNotCreatedList([...respdata.results.res])
        }
        setloaderFlag(false);
        eventdayarrNotCreatedListFetched(true);
    }

    useEffect(() => {
        if (eventdayarrNotCreatedList && eventdayarrNotCreatedList.length === 0 && !listFetchSuccess) {
            setListFetchSuccess(true);
            getList()
        }

    }, [eventdayarrNotCreatedList]);

    return (
        <>
            {loaderFlag == true ? (
                <Box className="loaderProgress" sx={{ width: "100%", mt: "10px" }}>
                    <LinearProgress />
                </Box>
            ) : (
                ""
            )}

            <div className="reactTableWrapper miscList">
                <div className="rolelist_mainwrp_Table">
                {!loaderFlag && eventdayarrNotCreatedList !== undefined ? (
                    <ListingTable
                        tableData={eventdayarrNotCreatedListObj}
                        dataset={eventdayarrNotCreatedList}
                        modifyHeaders={modifyTableHeaders}
                    />
                ) : (<TableSkeleton count={5} />)}
                </div>
            </div>
        </>
    )
}